var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-index"},[_c('div',{staticClass:"no-app"},[_c('img',{attrs:{"src":require("@/assets/img/501.png"),"alt":""}}),_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('code501')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }